var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThankYouImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 224,
    viewBox: "0 0 147 224",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E9999F",
    strokeWidth: 2.529,
    d: "m17 120-1 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.572 108-25.858-3.8c-2.048-.515-3.735-2.057-4.47-4.092L56 77.244 67.347 70l7.658 22.277L96 98.169 94.572 108z",
    fill: "#202446",
    fillRule: "nonzero",
    stroke: "#202446",
    strokeWidth: 0.738
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#202446",
    strokeWidth: 0.738,
    d: "m100 117-1-10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9999F",
    strokeWidth: 2.529,
    fill: "#E9999F",
    fillRule: "nonzero",
    d: "m97 97 4 .338V103"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#202446",
    strokeWidth: 0.738,
    fill: "#202446",
    fillRule: "nonzero",
    d: "m98.975 95-1.056 8.83L97 109l1.368-.285L100 95.221z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 43s1.04 4.185 6 13",
    stroke: "#202446",
    strokeWidth: 0.738
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#E9999F"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.529,
    d: "m6.132 133 7.781-6.291M2 127.936l11.187-6.805-1.766 3.105M2.942 131.084l7.383-5.097-.36-.746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.423 124.61s.795-2.143 5.879-5.69l3.717-1.92-1.831 8.033-6.336 2.902-1.43-3.324z",
    strokeWidth: 0.738,
    fill: "#E9999F",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.19 127.35s.83-2.11 1.8-8.076l-7.148 3.341",
    stroke: "#E9999F",
    strokeWidth: 0.738,
    fill: "#E9999F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9999F",
    strokeWidth: 2.529,
    d: "m18 131.746-1.81-4.396-4.448.278"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D3343F",
    strokeWidth: 0.738,
    d: "m10.193 127.661-5.41 4.085M8.218 125.947l-5.15 3.362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.867 79.773-7.864 17.245-11.201 24.98s-5.547.294-9.802-5.521l18.985-43.544s2.683-4.672 9.08-5.443C46.463 66.72 55 67.088 55 67.088",
    stroke: "#202446",
    strokeWidth: 0.738,
    fill: "#202446",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.738
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.062 59.052s26.542 13.985 27.42 40.85M114.952 16.842s-12.42 32.007-13.08 49.86M129.016 28.946s-14.707 13.892-22.237 37.755M130.332 43.065s-16.688 11.998-25.43 27.548",
    stroke: "#202446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.495 64.996S107.9 62.603 98.482 99.903c0 0-.532 4.12-4.835 18.936",
    stroke: "#202446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.524 25.201s9.938 30.088 6.207 63.604l-2.313 12.048",
    stroke: "#202446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.758 44.577c1.024 0 31.822-6.666 25.724 55.325",
    stroke: "#202446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.782 29.024s26.917 42.198 24.7 70.878",
    stroke: "#202446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.14 15.804-.156.445.038.009c-1.18 4.484-5.743 7.154-10.185 5.965-4.444-1.19-7.09-5.793-5.91-10.276l.036.01.083-.466L109.807 1l3.694 7.707 4.472-5.995.935 7.442 6.995-4.842-2.763 10.492z",
    stroke: "#FCE461",
    fill: "#FFE462",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.81 72.418-.454.114.013.033c-4.366 1.45-9.077-.95-10.51-5.357-1.434-4.407.946-9.155 5.314-10.602l.01.037.433-.186 10.222-3.387-4.388 7.326 7.42.512-5.674 4.85 7.839 3.274-10.224 3.386z",
    stroke: "#D3343F",
    fill: "#D3343F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.726 75.776s5.289-5.601 11.368-.927c0 .001-4.528 5.372-11.368.927zM103.426 36.997s2.989 7.123-3.679 10.89c0 0-3.085-6.326 3.68-10.89zM138.623 31.802l-.348.32.028.025a8.28 8.28 0 0 1-11.772.352c-3.345-3.18-3.502-8.497-.352-11.871l.03.026.29-.372 7.378-7.9-.386 8.55 6.76-3.126-2.689 6.992L146 23.9l-7.377 7.902zM109.504 29.429a5.355 5.355 0 0 1 7.477-1.466c2.468 1.68 3.116 5.06 1.451 7.549-1.664 2.483-5.013 3.142-7.478 1.462-2.466-1.677-3.117-5.058-1.45-7.545z",
    stroke: "#202446",
    fill: "#202446",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.494 46.163c1.695-2.878.758-6.598-2.092-8.309a5.977 5.977 0 0 0-8.233 2.113c-1.697 2.878-.762 6.599 2.092 8.31 2.854 1.708 6.538.759 8.233-2.114z",
    stroke: "#D3343F",
    fill: "#D3343F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m102.197 21.043-3.86-8.347-5.81 2.056-2.32.82-5.808 2.054 2.157 8.954s1.431 8.064 9.331 5.32h0l.068-.022 2.182-.772.069-.023-.001-.003c7.868-2.839 3.992-10.037 3.992-10.037z",
    stroke: "#D3343F",
    fill: "#D3343F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.379 12.68c.354 1.023-2.485 2.96-6.345 4.324-3.86 1.368-7.275 1.644-7.634.622-.354-1.024 2.485-2.962 6.345-4.326 3.86-1.37 7.278-1.643 7.634-.62z",
    stroke: "#202446",
    fill: "#202446"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.172 31.19c-1.186-3.125.364-6.63 3.46-7.825 3.1-1.201 6.573.363 7.76 3.49 1.187 3.124-.36 6.631-3.46 7.828-3.1 1.198-6.573-.365-7.76-3.493z",
    stroke: "#202446",
    fill: "#202446",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.399 46.75c-1.187-3.128.363-6.636 3.46-7.832 3.098-1.196 6.572.37 7.76 3.493 1.187 3.122-.362 6.628-3.463 7.827-3.096 1.197-6.571-.368-7.757-3.489z",
    stroke: "#D3343F",
    fill: "#D3343F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.914 44.936c-1.186-3.122.363-6.63 3.46-7.828 3.099-1.196 6.572.37 7.76 3.494 1.186 3.123-.363 6.628-3.461 7.827-3.1 1.196-6.574-.367-7.76-3.493z",
    stroke: "#FCE461",
    fill: "#FFE462",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.876 56.226c1.853-2.775 5.589-3.508 8.337-1.634 2.752 1.871 3.475 5.64 1.62 8.415-1.856 2.77-5.59 3.504-8.34 1.631-2.75-1.872-3.475-5.64-1.617-8.412z",
    stroke: "#D3343F",
    fill: "#D3343F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.768 69.13c-1.718 7.656-6.985 25.756-7.822 32.511M114.41 30.962s-2.833 14.36-7.63 35.739",
    stroke: "#202446"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m119.343 59.087 2.117-5.803-3.255-2.234-1.3-.894-3.255-2.235-4.575 4.12s-5.933 4.763.134 8.99h0l.051.037 1.69 1.16.051.038.003-.004c6.125 4.142 8.339-3.175 8.339-3.175z",
    stroke: "#D3343F",
    fill: "#D3343F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.483 53.3c-.275.557-2.315-.219-4.547-1.751-2.234-1.534-3.698-3.164-3.286-3.627.399-.446 2.412.37 4.51 1.81 2.097 1.437 3.588 3.03 3.323 3.568z",
    stroke: "#202446",
    fill: "#202446"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#202446",
    d: "M97.946 101.641 95.3 118.289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.158 67.842c-1.187-3.122.363-6.63 3.46-7.829 3.098-1.195 6.572.37 7.76 3.494 1.187 3.125-.363 6.63-3.461 7.83-3.099 1.196-6.572-.369-7.76-3.495z",
    stroke: "#FCE461",
    fill: "#FFE462",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#202446",
    d: "M98.482 99.902 97.118 120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.577 72.515s5.037-5.835 11.317-1.44c0 .002-4.286 5.573-11.317 1.44z",
    stroke: "#202446",
    fill: "#202446",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9999F",
    strokeWidth: 0.738,
    fill: "#E9999F",
    fillRule: "nonzero",
    d: "M16 208.332 22.126 196 29 199.877 21.625 214"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D3343F",
    fillRule: "nonzero",
    stroke: "#D3343F",
    strokeWidth: 0.738
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.575 152.436 54.126 99M38.538 106.874s-4.955 2.244-6.444 16.802c-1.65 16.118-2.417 37.541-2.417 37.541L16 193.754s4.743 11.164 18.696 8.957l13.209-30.657s4.034-9.371 3.946-15.495l3.149-33.9-2.027-19.106"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9999F",
    strokeWidth: 0.738,
    fill: "#E9999F",
    fillRule: "nonzero",
    d: "M73.766 216.56 71 203.162 78.971 202 82 217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.335 109.711 84 201.723s-8.608 8.045-19.361 2.068L44 107",
    stroke: "#D3343F",
    strokeWidth: 0.738,
    fill: "#D3343F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.932 110.448 67.308 76.9s2.06-5.376-.927-8.21c-1.89-1.794-3.595-1.689-5.768-1.687l-14.53.408c-4.28 0-10.214 1.278-12.193 6.31-1.805 4.59-.307 7.086-.307 7.086l2.562 29.526c.001 0 12.476 5.925 29.787.116z",
    stroke: "#202446",
    strokeWidth: 0.738,
    fill: "#202446",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D3343F",
    strokeWidth: 0.738,
    fill: "#D3343F",
    fillRule: "nonzero",
    d: "M49 46.777 49.227 65 62 62.795 55.03 44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.798 47.061c-2.158-7.09-4.7-5.494-7.234-5.92-2.32-.404-4.78.051-6.922 1.457-4.652 3.045-6.038 9.42-3.101 14.238 2.939 4.821 9.026 6.59 13.884 3.917 5.02-2.763 5.52-6.637 3.373-13.692z",
    stroke: "#E9999F",
    strokeWidth: 0.738,
    fill: "#E9999F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9999F",
    strokeWidth: 0.738,
    fill: "#E9999F",
    fillRule: "nonzero",
    d: "M46 69h9V59l-9 2.257z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 66.62s1.146 5.482 9.93 5.379c8.787-.108 9.07-5.714 9.07-5.714s-10.448-.827-19 .336z",
    stroke: "#E9999F",
    strokeWidth: 0.738,
    fill: "#E9999F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.654 47.57 57 43.262s-5.2-8.269-14.87-1.774c-2.37 1.591-2.886 3.816-3.64 6.18C37.739 50.035 35 65 35 65l11.565-1.209-.873-16.218-.038-.004z",
    stroke: "#D3343F",
    strokeWidth: 0.738,
    fill: "#D3343F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.738
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.705 55.702s-1.011 1.843-2.975 1.137",
    stroke: "#D3343F"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#202446",
    d: "m54.464 51.526 1.654 1.758-1.6.67M51.816 51.063c.056.433-.113.885-.463 1.126-.466.319-1.07.147-1.353-.385M57.99 49c.055.433-.114.885-.463 1.127-.467.318-1.072.146-1.354-.385"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m55 129-3.034 30.533s-.4 5.718-3.74 12.857L35 203",
    stroke: "#202446",
    strokeWidth: 0.738
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.67 40.023c-.532 1.66-2.425 2.607-4.23 2.116-1.804-.49-2.833-2.232-2.3-3.891.533-1.658 2.427-2.61 4.23-2.119 1.805.491 2.833 2.237 2.3 3.894z",
    stroke: "#D3343F",
    strokeWidth: 0.738,
    fill: "#D3343F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 39.852s-3.435 1.31-4.785 3.148",
    stroke: "#202446",
    strokeWidth: 0.832
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.373 51s.363 2.618-1.488 2.116c-1.602-.436-2.514 1.218-1.38 2.458.756.828 2.57 2.323 4.495.706",
    stroke: "#E9999F",
    strokeWidth: 0.738,
    fill: "#E9999F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.334 54.072.165.153.012-.02c1.748 1.314 1.992 4.205.545 6.455-1.448 2.25-4.039 3.009-5.788 1.697l.012-.02-.19-.114L61 59.15l4.188-.868-1.739-3.338 3.5.6L66.245 51l4.09 3.072z",
    stroke: "#FCE461",
    strokeWidth: 0.738,
    fill: "#FFE462",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.543 106.549s5.119.883 5.78-1.734c1.196-4.717.823-6.406-1.25-6.815",
    stroke: "#E9999F",
    strokeWidth: 2.529,
    fill: "#E9999F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9999F",
    strokeWidth: 2.529,
    fill: "#E9999F",
    fillRule: "nonzero",
    d: "m96.044 99.843 3.755.028 2.273 1.521M100.961 103.178l-4.938-.037M100.882 106.586 96 106.549"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D3343F",
    strokeWidth: 0.738,
    d: "m96.062 101.513 4.433.034M96.011 104.783l4.393.032M96.052 98.743l4.626.036"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.929 221.338 22 218.282 25.58 217c.812.23.388.19 1.21.3.115.018.594.314.71.322 3.35.23 5.523 1.348 5.5 2.833-.031 2.48-2.324 2.553-3.905 2.545l-3.062-.001 1.707-.379M90.715 218.023c2.42.327 4.3 1.382 4.285 2.85-.024 2.455-2.106 2.105-3.615 2.115L72 222.987l1.185-7.64s1.65 1.47 4.4 1.499c1.769.016 2.763-.236 3.821-2.846 0 0 4.622 3.392 9.309 4.023z",
    stroke: "#202446",
    strokeWidth: 0.738,
    fill: "#202446",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.845 218.123c-4.452-.394-5.77-7.518-5.77-7.518-2.341 1.458-3.343 1.09-4.874.074-2.375-1.583-3.01-3.679-3.01-3.679L10 212.349l11.458 9.255s2.22 1.605 4.832 1.373l3.71-.33-.71-2.438",
    stroke: "#202446",
    strokeWidth: 0.738,
    fill: "#202446",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYouImage);
export default __webpack_public_path__ + "static/media/ThankYouImage.d71cf2a5936046369223daa511beb0d6.svg";
export { ForwardRef as ReactComponent };